//08-2. 가상 코인 거래소의 공용 컴포넌트 만들기

///08-2-6. Modal 컴포넌트 만들기

///08-2-6-2. 공급자와 소비자 생성하기

import React from 'react';
export const { Provider, Consumer } = React.createContext({});